import {
  PropertyFeesResponse,
  ReservationActionTypes,
} from "./../../actions/actionTypes/reservation/types";
import {
  ADD_RESERVATIONS,
  UPDATE_APP_MODE,
  SET_PROPERTY_FEES,
  SET_BLACKLIST,
  SET_BLACKLIST_RECOVERY,
  SET_SUPER_BLACKLIST,
  SET_RECOVERY_PAYMENT_CLEARED,
  SET_CURRENT_RESERVATION_ID,
} from "./../../actions/actionTypes/reservation/index";
import { AppMode } from "../../../enums";

interface InitialState {
  reservations: any[];
  isBlacklisted: boolean;
  isBlacklistedRecovery: boolean;
  isSuperBlacklist: boolean;
  isRecoveryPaymentCleared: boolean;
  appMode: typeof string;
  propertyFees: PropertyFeesResponse | null;
  currentReservationId: any;
}
const initialState: InitialState = {
  reservations: [],
  isBlacklisted: false,
  isBlacklistedRecovery: false,
  isSuperBlacklist: false,
  isRecoveryPaymentCleared: true,
  appMode: "NORMAL",
  propertyFees: null,
  currentReservationId: null,
};

export function reservation(state = initialState, action: ReservationActionTypes) {
  switch (action.type) {
    case ADD_RESERVATIONS:
      const { reservations } = action;
      return {
        ...state,
        reservations,
      };
    case UPDATE_APP_MODE:
      const { appMode } = action;
      // console.log(`Update app mode called, new app Mode: ${appMode}  Old one: ${state.appMode}`);
      return {
        ...state,
        appMode,
      };
    case "SET_PROPERTY_FEES_SUCCESS":
      const { payload } = action;
      const { data } = payload;
      return {
        ...state,
        propertyFees: data,
      };
    case SET_BLACKLIST:
      // console.log(`Setting black list`, action);
      return {
        ...state,
        isBlacklisted: action.isBlacklisted,
      };
    case SET_BLACKLIST_RECOVERY:
      // console.log(`Setting black list for recovery`, action);
      return {
        ...state,
        isBlacklistedRecovery: action.isBlacklistedRecovery,
      };
    case SET_RECOVERY_PAYMENT_CLEARED:
      return {
        ...state,
        isRecoveryPaymentCleared: action.isRecoveryPaymentCleared,
      };
    case SET_SUPER_BLACKLIST:
      // console.log(`Setting super black list`, action);
      return {
        ...state,
        isSuperBlacklist: action.isSuperBlacklist,
      };
    case SET_CURRENT_RESERVATION_ID:
      return {
        ...state,
        currentReservationId: action.currentReservationId,
      };
    default:
      return {
        ...state,
        appMode: state.appMode ? state.appMode : AppMode.NORMAL,
      };
  }
}
